<app-text-input class="flex w-100 select-search-input"
  [input]="searchControl"
  [disabled]="searchControl.disabled"
  [fromSearch]="true"
  [placeholder]="'global.search' | translate">
  <!--img icon-prefix class="filter-grey" src="assets/icons/search-md.svg" height="16px" alt=""/-->
  @if (searchControl.value?.length > 0) {
    <app-icon-button icon-suffix [img]="'assets/icons/close.svg'" size="xs" color="primary" [panelClass]="'img-size-30'"
      [disabled]="searchControl.disabled"
    (click)="searchControl.reset('')"></app-icon-button>
  }
</app-text-input>
